import * as React from "react";
import styled, { css } from "react-emotion";
import { breakpoints, spacing } from "../theme/layout";
import { greyColors, primaryColors } from "../theme/colors";
import { small, strong } from "../theme/typefaces";
import { Icon } from "../theme/icons";
export const AccordionContainer = styled("div") `
  width: 100%;
  ${spacing.ma1};
  ${spacing.ph0};
  ${spacing.pt2};
  ${spacing.pb0};
  ${breakpoints.large `
    ${spacing.pr0};
  `};
  ${breakpoints.smallDown `
    ${spacing.ph1};
  `};
`;
export const AccordionItem = styled("div") `
  border-top: 1px solid ${greyColors["200"]};
  :last-child {
    border-bottom: 1px solid ${greyColors["200"]};
  }
`;
export const accordionLabelStyle = css `
  ${small};
  ${strong};
  ${spacing.pr2};
  ${spacing.pl0};
  ${spacing.pv0};
  width: 100%;
  line-height: 54px;
  cursor: pointer;
  color: ${primaryColors.zuerichBlue};
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  transition: color 0.3s ease;
  & svg {
    color: ${greyColors["600"]};
  }
  &:hover,
  :focus {
    color: ${primaryColors.darkGrey};
  }
  &:active {
    outline: none;
  }
`;
export const accordionLabelActiveStyle = css `
  ${accordionLabelStyle};
  outline: none;
  color: ${primaryColors.darkGrey};
`;
export const accordionContentStyle = css `
  ${small};
  overflow: hidden;
  box-sizing: border-box;
  max-height: 0;
`;
export const accordionContentActiveStyle = css `
  ${accordionContentStyle};
  ${spacing.pb2};
  max-height: 500vh;
  overflow: visible;
`;
export class Accordion extends React.Component {
    render() {
        const { items, active } = this.props;
        return (<AccordionContainer>
        {items.map(d => {
            const icon = active === d.label ? "ChevronUp" : "ChevronDown";
            return (<AccordionItem key={d.label}>
              <button className={active === d.label
                ? accordionLabelActiveStyle
                : accordionLabelStyle} value={d.label} onClick={e => this.props.onAccordionLabelClick(e)} id={`accordion-toggle-${d.label}`} aria-controls={`accordion-panel-${d.label}`} aria-expanded={active === d.label ? "true" : "false"}>
                {d.label}
                <div style={{ fontSize: "1.2em" }}>
                  <Icon name={icon}/>
                </div>
              </button>
              <div // FIXME : Nice transition on max-height
             className={active === d.label
                ? accordionContentActiveStyle
                : accordionContentStyle} id={`accordion-panel-${d.label}`} aria-labelledby={`accordion-toggle-${d.label}`}>
                {d.content}
              </div>
            </AccordionItem>);
        })}
      </AccordionContainer>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Accordion.tsx